import React, { Component } from 'react';

import branch from 'client/core/branch';
import { SCREEN_ID_SEARCH_FILTERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import {
  Search as SearchActions,
} from 'client/actions';

import Navbar from 'client/components/Navbar';
import NavbarButton from 'client/components/NavbarButton';
import SrFilterDate from 'client/components/SrFilterDate';
import ButtonDeprecated, {
  BUTTON_THEME_BLUE,
} from 'client/components/ButtonDeprecated';

@withTransitionHook
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
@branch({
  filters: ['search', 'filters'],
})
class FilterPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: 'Onboarding',
    // canonical: '/',
    // keywords: 'some, keywords',
    // description: 'Site description here.',
  })

  constructor(props) {
    super(props);

    const { filters } = props;

    this.state = {
      moveInDate: filters.moveInDate,
      availableHomesNearMoveInDate: filters.availableHomesNearMoveInDate || false,
    };
  }

  _onSubmitFilter = () => {
    const {
      history,
      dispatch,
    } = this.props;

    const {
      moveInDate,
      availableHomesNearMoveInDate,
    } = this.state;

    dispatch(SearchActions.updateFilter, {
      filterKey: 'moveInDate',
      filterValue: moveInDate,
    });

    dispatch(SearchActions.updateFilter, {
      filterKey: 'availableHomesNearMoveInDate',
      filterValue: availableHomesNearMoveInDate,
    });

    history.push('/search');
  }

  _isValid = () => {
    const {
      moveInDate,
    } = this.state;

    return moveInDate && true;
  }

  _handleOnAvailableHomesNearMeCheckboxClick = (event) => {
    this.setState({ moveInDate: event });
  }

  render() {
    const {
      moveInDate,
      availableHomesNearMoveInDate,
    } = this.state;

    const {
      history,
    } = this.props;

    return (
      <div className='modal specificFilter'>
        <div className='moveDate'>
          <div className='modal filters specificFilter'>
            <Navbar
              leftButton={(
                <NavbarButton onClick={() => history.push('/search')}>
                  Cancel
                </NavbarButton>
              )}
            />
            <div className='contentContainer'>
              <span className='headline'>Move-in date</span>
              <SrFilterDate
                onChange={this._handleOnAvailableHomesNearMeCheckboxClick}
                value={moveInDate}
              />
              <div className='row switch'>
                <span className='title'>
                  Only show homes that fit my move-in.
                </span>
                <input
                  className='switch'
                  type='checkbox'
                  onChange={(event) => this.setState({ availableHomesNearMoveInDate: event.target.checked })}
                  checked={availableHomesNearMoveInDate}
                />
              </div>
              <div className='saveFilterContainer'>
                <ButtonDeprecated
                  theme={BUTTON_THEME_BLUE}
                  onClick={this._onSubmitFilter}
                >
                  done
                </ButtonDeprecated>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FilterPage.displayName = 'FilterPage';

export default FilterPage;
